// extracted by mini-css-extract-plugin
export default {"main":"Card_main__MRbn1","nftImgContainer":"Card_nftImgContainer__e8-8b","popup":"Card_popup__oX7-0"};